import React, { useEffect, useState } from 'react';
import { Box, Button, FormControlLabel, Menu, MenuItem, Radio, RadioGroup } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns'; // You can replace this with another date adapter if needed
import CustomButton from '../CustomButton/CustomButton';
import CustomDatePicker from '../CustomDatePicker/CustomDatePicker';
import { FilterIcon } from '../Icons';
import moment from 'moment';
import { SelectedOptions } from '../../pages/Orders/Orders';
import { convertUTCDateIntoIndianTimezone } from '@src/helpers/Helpers';

const customBackdropStyle: React.CSSProperties = {
	backgroundColor: 'transparent',
};

interface DateFilterMenuProps {
	rows: any;
	selectedOption: any;
	setSelectedOption: any;
	selectedOptions: SelectedOptions | null;
	customStartDate: Date | null;
	customEndDate: Date | null;
	setCustomStartDate: (date: Date | null) => void;
	setCustomEndDate: (date: Date | null) => void;
	getFilterData: any;
	style?: React.CSSProperties;
}

const DateFilterMenu: React.FC<DateFilterMenuProps> = ({
	rows,
	selectedOptions,
	selectedOption,
	setSelectedOption,
	customStartDate,
	customEndDate,
	setCustomStartDate,
	setCustomEndDate,
	getFilterData,
	style,
}) => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		setSelectedOption(value);
	};

	const isCustomSelected = selectedOption === 'Custom';

	const handleStartDate = (date: Date | null) => {
		setCustomStartDate(convertUTCDateIntoIndianTimezone(date as Date));
	};
	const handleEndDate = (date: Date | null) => {
		setCustomEndDate(convertUTCDateIntoIndianTimezone(date as Date));
	};

	const handleClear = () => {
		setSelectedOption('All');
		setCustomEndDate(null);
		setCustomStartDate(null);

		//next call
		getFilterData('default', selectedOptions, rows, null, null);
	};

	const disableApply = () => {
		if (selectedOption === 'Custom') {
			if (!customStartDate || !customEndDate) {
				return true;
			}
		}
		return false;
	};
	const handleApply = () => {
		getFilterData(selectedOption, selectedOptions, rows, customStartDate, customEndDate);
		setAnchorEl(null);
	};

	// useEffect(() => {
	// 	// getFilterData('All', selectedOptions, rows, customStartDate, customEndDate);
	// }, []);

	return (
		<div style={style}>
			<CustomButton
				color="secondary"
				StartIcon={<FilterIcon />}
				handleClick={handleMenuOpen}
				title="Order Date"
				styles={{ height: '36px' }}
			/>
			<Menu
				MenuListProps={{
					sx: {
						py: '5px',
					},
				}}
				PaperProps={{
					sx: {
						width: '293px',
						borderRadius: '4px',
						mt: 1,
						boxShadow: '0px 10px 25px 0px #0000001A',
					},
				}}
				BackdropProps={{
					style: customBackdropStyle,
				}}
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleMenuClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				<MenuItem
					sx={{
						py: 0,
						':hover': { backgroundColor: 'transparent' },
					}}
				>
					<RadioGroup value={selectedOption} onChange={handleOptionChange}>
						<FormControlLabel
							value="All"
							sx={{
								height: '35px',
							}}
							control={<Radio />}
							label="All"
						/>
						<FormControlLabel
							value="Today"
							sx={{
								height: '35px',
							}}
							control={<Radio />}
							label="Today"
						/>
						<FormControlLabel
							value="Last Week"
							sx={{ height: '35px' }}
							control={<Radio />}
							label="Last week"
						/>
						<FormControlLabel
							value="Last Month"
							sx={{ height: '35px' }}
							control={<Radio />}
							label="Last Month"
						/>
						<FormControlLabel
							value="Custom"
							sx={{ height: '35px' }}
							control={<Radio />}
							label="Custom"
						/>
					</RadioGroup>
				</MenuItem>
				{isCustomSelected && (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							padding: '0px 16px',
						}}
					>
						<CustomDatePicker
							label="Start"
							styles={{ width: '127px' }}
							selectedDate={customStartDate}
							onDateChange={handleStartDate}
						/>
						<CustomDatePicker
							label="End"
							styles={{ width: '127px' }}
							minDate={customStartDate}
							selectedDate={customEndDate}
							onDateChange={handleEndDate}
						/>
					</div>
				)}
				<Box
					sx={{
						mt: '8px',
						display: 'flex',
						padding: '6px 16px',
						alignItems: 'center',
						justifyContent: 'space-between',
						borderTop: '1.5px solid #F1F1F1',
					}}
				>
					<Button
						sx={{
							color: 'errorColor.main',
							p: 0,
							height: 'auto',
							justifyContent: 'flex-start',
							':hover': {
								backgroundColor: 'transparent',
							},
						}}
						onClick={handleClear}
					>
						Clear
					</Button>
					<CustomButton
						title="Apply"
						handleClick={handleApply}
						disabled={disableApply()}
						heightVariant="medium"
						color="primary"
						styles={{
							width: '68px',
							height: '36px',
							background: 'var(--btn-color-grey)',
							color: 'var(--default-text-color)',
							':hover': {
								background: 'var(--btn-hover-color) !important',
							},
						}}
					/>
				</Box>
			</Menu>
		</div>
	);
};

export default DateFilterMenu;
